import React from 'react';

export default function FaleConoscoIframe() {
  const handleRedirect = () => {
    window.open('https://www.fo.ufu.br/contact', '_blank');
    window.location.href = '/';
  };

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <button onClick={handleRedirect} style={{ fontSize: 18, padding: '10px 20px' }}>
        Ir para Fale Conosco
      </button>
    </div>
  );
}